import React, { useEffect, useState } from "react";
import { fetchFansLeaderboard, FanBoardRow, FanRow } from "./FansLeaderboardSheet";
import FanCardSheet from "./FanCardSheet";
import LeaderboardFlame from "./LeaderboardFlame";
import "./DJLeaderboard.css";
import "./FansLeaderboardSheet.css";
import { t } from "../i18n";
import { useAccountCache } from "../hooks/useAccountCache";

// DJ-side Top Fans tab on the leaderboard page — the same platform-wide
// Top Spenders board fans see in the header-pill sheet, in the card shell
// the neighboring Top DJs tab uses. Data + session cache shared with the
// sheet via fetchFansLeaderboard.

const TopFansBoard: React.FC = () => {
  // Kept for the session, like the other boards: no skeleton flash on a switch.
  const [fans, setFans] = useAccountCache<FanRow[] | null>("topfans", null);
  const [openFan, setOpenFan] = useState<FanRow | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchFansLeaderboard()
      .then((rows) => {
        if (!cancelled) setFans(rows);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [setFans]);

  if (failed) return <div className="djlb-empty">{t("topFansBoard.couldnTLoadTop")}</div>;

  return (
    <div className="djlb-cards">
      <div className="djlb-card">
        <div className="djlb-card-title"><LeaderboardFlame size={20} />{t("topFansBoard.topFans")}</div>
        {!fans ? (
          <div className="djlb-skel" aria-hidden="true">
            {Array.from({ length: 5 }).map((_, i) => (
              <div className="djlb-skel-row" key={i} />
            ))}
          </div>
        ) : fans.length === 0 ? (
          <div className="djlb-empty">{t("topFansBoard.noSpendersYet")}</div>
        ) : (
          <ol className="flb-list flb-list--board">
            {fans.map((f, i) => (
              <FanBoardRow key={`${f.name}-${i}`} fan={f} i={i} sub={t("topFansBoard.requestsCount", { count: f.requests })} onOpen={setOpenFan} />
            ))}
          </ol>
        )}
      </div>
      <FanCardSheet fan={openFan} onClose={() => setOpenFan(null)} />
    </div>
  );
};

export default TopFansBoard;
